const ServicesSection = () => {
  const services = [
    {
      icon: "💻",
      title: "Software Development",
      description:
        "Custom software solutions tailored to your business needs with cutting-edge technologies and best practices.",
      features: ["Web Applications", "API Development", "Legacy System Modernization", "DevOps & CI/CD"],
    },
    {
      icon: "🔄",
      title: "Digital Transformation",
      description:
        "Modernize your business processes and leverage technology to stay competitive in the digital landscape.",
      features: ["Process Automation", "Digital Strategy", "Cloud Migration", "Data Analytics"],
    },
    {
      icon: "📱",
      title: "Mobile Applications",
      description:
        "Native and cross-platform mobile applications that deliver exceptional user experiences across devices.",
      features: ["iOS Development", "Android Development", "React Native", "Flutter"],
    },
    {
      icon: "🛡️",
      title: "Cybersecurity",
      description: "Protect your digital assets with comprehensive security solutions and proactive threat management.",
      features: ["Security Audits", "Penetration Testing", "Compliance", "Security Training"],
    },
    {
      icon: "☁️",
      title: "Cloud Services",
      description: "Leverage the power of cloud computing to scale your business and reduce operational costs.",
      features: ["AWS", "Azure", "Google Cloud", "Private Cloud"],
    },
    {
      icon: "🤖",
      title: "AI & Machine Learning",
      description: "Harness the power of artificial intelligence to gain insights and automate complex processes.",
      features: ["Predictive Analytics", "Natural Language Processing", "Computer Vision", "Recommendation Systems"],
    },
  ]

  return (
    <section className="py-20 bg-white relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-gray-600">
            We offer a comprehensive range of technology services to help your business innovate and grow.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 relative overflow-hidden group"
            >
              {/* Decorative gradient */}
              <div className="absolute -right-6 -top-6 w-16 h-16 bg-gradient-to-r from-blue-400/20 to-blue-600/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative z-10">
                <div className="mb-4 bg-blue-50 w-14 h-14 rounded-lg flex items-center justify-center text-2xl">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>

                <ul className="space-y-2">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-center text-gray-700">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="mt-6 flex items-center">
                  <div className="h-px w-8 bg-gradient-to-r from-blue-400 to-blue-600"></div>
                  <button className="text-blue-600 font-medium text-sm ml-2 hover:text-blue-700 transition-colors">
                    Learn more
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServicesSection
